import { defineComponent as _defineComponent } from 'vue'
import EditInitialDepositModal from "@/components/ui/modals/EditInitialDepositModal.vue";
  import CompletedResForm from "@/components/ui/modals/CompletedResForm.vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import { computed, onMounted, ref } from "vue";
  import router from "@/router";
  import { toKebabCase } from "@/helpers/transformation/string";
  import { EoiGroupByLotInterface, EoiInterface } from "@/types/EoiInterface";
  import { useStore } from "vuex";
  import { EoiStatus } from "@/enums/EoiStatus";
  import {
    eoiStatuses,
    EoiStatusFilterLabel,
    EoiStatusFilterValues,
  } from "@/constants/statusFilters";
  import plural from "@/features/plural";
  import { formatDate } from "@/helpers/date";
  import { getEoiStatusClass } from "@/helpers/status";
  import SendEoiDocumentsModal from "@/components/ui/modals/SendEoiDocumentsModal.vue";
  import { EstateInterface } from "@/types/EstateInterface";
  import { useRequest } from "@/features/useRequest";
  import { POSITION } from "vue-toastification";
  import { EstateActions } from "@/store/modules/estate";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'EOIView',
  setup(__props, { expose: __expose }) {
  __expose();

  const store = useStore();
  const lotsActive = ref<EoiGroupByLotInterface[]>([]);
  const estate = ref<EstateInterface | null>(null);
  const loading = ref(false);
  const estateLoading = ref(false);
  const editInitialDepositModal = ref(false);
  const openCompletedResForm = ref(false);
  const openSendEoiDocumentsModal = ref(false);
  const filters = eoiStatuses;
  const activeFilter = ref(eoiStatuses[0]);
  const eoiId = ref("");

  const estateId = computed(() => {
    return store.state.user.selectedEstateId;
  });

  const estateHasCollaborators = computed(() => {
    const collaboratorsLength = estate.value?.collaboratorBusiness?.length;

    return !!collaboratorsLength;
  });

  const tableHeaders = computed(() => {
    const headers = [
      "",
      "Lot No.",
      "Street Name",
      "Name",
      "Email",
      "Phone",
      "Submitted",
      "Status",
    ];

    if (estateHasCollaborators.value) {
      headers.push("Business");
    }

    return headers;
  });

  const lots = computed(() => {
    return getSortedLots();
  });

  const counter = computed(() => {
    return getEoiCount(lotsActive.value);
  });

  onMounted(() => {
    getEois();
    getEstate();
  });

  function changeFilter(item: {
    label: EoiStatusFilterLabel;
    value: EoiStatusFilterValues;
  }) {
    activeFilter.value = item;
    getEois();
  }

  const getEstate = async () => {
    const { handleRequestWithLoading } = useRequest(
      undefined,
      undefined,
      POSITION.TOP_LEFT
    );
    const res = await handleRequestWithLoading<EstateInterface, string>(
      EstateActions.GET_ESTATE,
      estateId.value,
      estateLoading
    );

    estate.value = res.data;
  };

  function getEois() {
    loading.value = true;
    store
      .dispatch("eoi/getEoisGroupByLot", {
        estateId: estateId.value,
        status: getFilterStatus(),
      })
      .then((res) => {
        lotsActive.value = res.data;
      })
      .finally(() => {
        loading.value = false;
      });
  }

  const getSortedLots = () => {
    return lotsActive.value
      .map((lot) => ({
        ...lot,
        eois: [...lot.eois].sort(sortEois),
      }))
      .sort(sortLots);
  };

  const sortLots = (a: EoiGroupByLotInterface, b: EoiGroupByLotInterface) => {
    return getEoiCreatedAt(b.eois[0]) - getEoiCreatedAt(a.eois[0]);
  };

  const sortEois = (a: EoiInterface, b: EoiInterface) => {
    return getEoiCreatedAt(b) - getEoiCreatedAt(a);
  };

  const getEoiCreatedAt = (eoi?: EoiInterface) => {
    return eoi ? new Date(eoi.createdAt).getTime() : 0;
  };

  const closeCompletedResForm = () => {
    openCompletedResForm.value = false;
  };

  const getFilterStatus = () => {
    if (Array.isArray(activeFilter.value.value)) {
      return activeFilter.value.value;
    }

    return [activeFilter.value.value];
  };

  function checkApproveDisabled(lot: EoiGroupByLotInterface) {
    return lot.eois.some(
      (eoi) => eoi.status === EoiStatus.WAITING_FOR_APPROVED
    );
  }

  function getEoiCount(groupLot: EoiGroupByLotInterface[]) {
    return groupLot.reduce(
      (accumulator: number, item: EoiGroupByLotInterface) => {
        return accumulator + item.eois.length;
      },
      0
    );
  }

  function onRow(row: EoiInterface, lot: EoiGroupByLotInterface) {
    if (
      !checkApproveDisabled(lot) ||
      row.status === EoiStatus.WAITING_FOR_APPROVED ||
      row.status === EoiStatus.WAITING_FOR_DECLINED
    ) {
      router.push(`/eoi/${row._id}`);
    }
  }

const __returned__ = { store, lotsActive, estate, loading, estateLoading, editInitialDepositModal, openCompletedResForm, openSendEoiDocumentsModal, filters, activeFilter, eoiId, estateId, estateHasCollaborators, tableHeaders, lots, counter, changeFilter, getEstate, getEois, getSortedLots, sortLots, sortEois, getEoiCreatedAt, closeCompletedResForm, getFilterStatus, checkApproveDisabled, getEoiCount, onRow, EditInitialDepositModal, CompletedResForm, DropDown, computed, onMounted, ref, get router() { return router }, get toKebabCase() { return toKebabCase }, get EoiGroupByLotInterface() { return EoiGroupByLotInterface }, get EoiInterface() { return EoiInterface }, get useStore() { return useStore }, get EoiStatus() { return EoiStatus }, get eoiStatuses() { return eoiStatuses }, get EoiStatusFilterLabel() { return EoiStatusFilterLabel }, get EoiStatusFilterValues() { return EoiStatusFilterValues }, get plural() { return plural }, get formatDate() { return formatDate }, get getEoiStatusClass() { return getEoiStatusClass }, SendEoiDocumentsModal, get EstateInterface() { return EstateInterface }, get useRequest() { return useRequest }, get POSITION() { return POSITION }, get EstateActions() { return EstateActions } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})